import { useTranslation } from 'react-i18next';
import { ConfigProvider } from 'antd';
import dayjs from 'dayjs';
import 'dayjs/locale/en';
import 'dayjs/locale/ru';
import 'dayjs/locale/zh-cn';
import 'dayjs/locale/ar';
import { antdLocales, dayjsLocales } from '~/utils/language/antdLocales';

type Lang = keyof typeof antdLocales;

const normalizeLang = (lang: string): Lang => {
    if (lang.startsWith('zh')) return 'zh';
    if (lang.startsWith('ar')) return 'ar';
    if (lang.startsWith('ru')) return 'ru';
    return 'en';
};

export const AntdLocaleProvider = ({ children }: { children: React.ReactNode }) => {
    const { i18n } = useTranslation();

    const lang = normalizeLang(i18n.language);

    dayjs.locale(dayjsLocales[lang] ?? 'en');

    return (
        <ConfigProvider
            locale={antdLocales[lang] ?? antdLocales.en} direction={lang === 'ar' ? 'rtl' : 'ltr'}>
            {children}
        </ConfigProvider>
    );
};
